import { Component, inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { interval } from "rxjs";
import { ProfileResolver } from "./resolvers/profile.resolver";
import { TimeClockService } from "./services/time-clock/time-clock.service";
import { differenceInMinutes } from "date-fns";
import { IconSetService } from "@coreui/icons-angular";
import {
  cilMenu,
  cilSettings,
  cilSun,
  cilMoon,
  cilContrast,
  cilX,
  cilBell,
  cilChevronLeft,
  cilChevronRight,
  cilFilter,
  cilPlus,
  cilSearch,
  cilDollar,
  cilPencil,
  cilTrash,
  cilSync,
  cilShare,
  cilMagnifyingGlass,
  cilPrint,
  cilEnvelopeClosed,
  cilMoney,
  cilSave,
  cilArrowLeft,
  cilUser,
  cilLockLocked,
  cilMinus,
  cilToggleOn,
  cilToggleOff,
  cilQrCode,
  cilZoomIn,
  cilFolder,
  cilCloudUpload,
  cilList,
  cilTags,
  cilPeople,
  cilBook,
} from "@coreui/icons";

@Component({
  // tslint:disable-next-line
  selector: "body",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent {
  title = "field-tech-fitness";

  private iconSetService = inject(IconSetService);

  constructor(
    private timeService: TimeClockService,
    private profileService: ProfileResolver,
    private toastrService: ToastrService
  ) {
    // Configure CoreUI icons
    this.iconSetService.icons = {
      cilMenu,
      cilSettings,
      cilSun,
      cilMoon,
      cilContrast,
      cilX,
      cilBell,
      cilChevronLeft,
      cilChevronRight,
      cilFilter,
      cilPlus,
      cilSearch,
      cilDollar,
      cilPencil,
      cilTrash,
      cilSync,
      cilShare,
      cilMagnifyingGlass,
      cilPrint,
      cilEnvelopeClosed,
      cilMoney,
      cilSave,
      cilArrowLeft,
      cilUser,
      cilLockLocked,
      cilMinus,
      cilToggleOff,
      cilToggleOn,
      cilQrCode,
      cilZoomIn,
      cilFolder,
      cilCloudUpload,
      cilList,
      cilTags,
      cilPeople,
      cilBook
    };

    interval(1800000).subscribe(() => {
      this.checkClockOut();
    });
  }

  checkClockOut() {
    if (this.profileService.isLogged()) {
      if (
        (!this.profileService.isClient() ||
          !this.profileService.isAdminClient()) &&
        this.profileService.profileInfo?.admin_company?.time_clock &&
        this.profileService.profileInfo?.admin_company?.required_clockin &&
        this.profileService.profileInfo?.admin_company?.business_hours
      ) {
        this.timeService.checkClock().subscribe((res) => {
          if (res.id) {
            let bHours = JSON.parse(
              this.profileService.profileInfo.admin_company.business_hours
            );
            let to = new Date();
            to.setHours(bHours.to.slice(0, 2));
            to.setMinutes(bHours.to.slice(3, 5));
            if (differenceInMinutes(to, new Date()) <= 30)
              this.toastrService.warning("Please remember to clock-out.");
          }
        });
      }
    }
  }
}
